// extracted by mini-css-extract-plugin
export default {"wrapper":"SecondaryMenu_wrapper__iIY-b","compact":"SecondaryMenu_compact__pWkis","menuItem":"SecondaryMenu_menuItem__3zsV0","subMenuItem":"SecondaryMenu_subMenuItem__3CIou"};